module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiv",
      "title": "iv"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_about",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Richard Estep")]), _vm._v(" ( Boulder, CO) first got involved with paranormal research in 1995 and has investigated haunted locations on both sides of the Atlantic. He is the author of numerous nonfiction books on the subject of paranormal research, and his work features on the TV shows "), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("Haunted Case Files, Haunted Hospitals, ")]), _vm._v("and "), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("Paranormal 911. ")]), _vm._v("Visit him online at www.richardestep.net.")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Robert Graves")]), _vm._v(" (Carmel, IN ) is the owner of Fox Hollow Farm. He has become something of a student of Herb Baumeister’s life … as both the man and the murderer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1801f507","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 57
// module chunks = 0